import { render, staticRenderFns } from "./project-create.vue?vue&type=template&id=b2848b20&"
import script from "./project-create.vue?vue&type=script&lang=ts&"
export * from "./project-create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports